import { useState, useEffect } from 'react';

const useTimeAgo = (createdAt) => {
  const [timeAgo, setTimeAgo] = useState('');

  const calculateTimeAgo = (timestamp) => {
    if (!timestamp) return 'N/A';
    
    const now = new Date();
    const created = new Date(timestamp);
    const diffInMs = now - created;
    
    const minutes = Math.floor(diffInMs / (1000 * 60));
    const hours = Math.floor(diffInMs / (1000 * 60 * 60));
    const days = Math.floor(diffInMs / (1000 * 60 * 60 * 24));
    
    if (days > 0) {
      return `${days}d ago`;
    } else if (hours > 0) {
      return `${hours}h ago`;
    } else if (minutes > 0) {
      return `${minutes}m ago`;
    } else {
      return 'Just now';
    }
  };

  useEffect(() => {
    // Calculate initial time
    setTimeAgo(calculateTimeAgo(createdAt));
    
    // Update every minute
    const interval = setInterval(() => {
      setTimeAgo(calculateTimeAgo(createdAt));
    }, 60000); // Update every 60 seconds
    
    return () => clearInterval(interval);
  }, [createdAt]);

  return timeAgo;
};

export default useTimeAgo;
